module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/ddae2f39a0d6a932cc13b73a3464aaa5.png";